export default __webpack_public_path__ + "static/media/EVOCON.b4535c0b.png";